import { render } from "./ViewActivateAccount.vue?vue&type=template&id=64be69eb&ts=true"
import script from "./ViewActivateAccount.vue?vue&type=script&lang=ts"
export * from "./ViewActivateAccount.vue?vue&type=script&lang=ts"

import "./ViewActivateAccount.vue?vue&type=style&index=0&id=64be69eb&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__